import { useState } from "react";
import SearchDialogAlert from "components/SearchInDialogAlert/components/SearchDialogAlert/SearchDialogAlert";
import { requestSearchStudentsByStudentId } from "services/general";

const DialogSearchStudent = ({
    loadingRequest,
    dialogShow, changeStudent, 
    getDataItemText
}) => {
    //#region States
    const [matchedStudentList, setMatchedStudentList] = useState([]);
    const [timeoutIdToSearch, setTimeoutIdToSearch] = useState(null);
    //#endregion
    //#region Functions
    const fillMatchedStudentList = async studentId => {
        // Borrando id del callback timeout si es que se teclea antes de la ejecución de la función
        clearTimeout(timeoutIdToSearch);
        // Programando ejecución de la búsqueda a 500ms
        const timeoutId = setTimeout(async () => {
            // Obteniendo referencia del elemento en focus
            const $input = document.activeElement;
            // Definiendo función de manejo del loader
            const handlerLoading = ({
                focusInInput, action
            }) => {
                if (!studentId) 
                    return;
                $input[focusInInput ? "focus" : "blur"]();
                action();
            }
            // Buscando lista de estudiantes según el código del estudiante pasado
            handlerLoading({
                focusInInput: false, 
                action: () => loadingRequest.show("Buscando estudiante...")
            });
            const studentList = !studentId ? [] : await requestSearchStudentsByStudentId(studentId);
            handlerLoading({
                focusInInput: true, 
                action: loadingRequest.hide
            });
            setMatchedStudentList(studentList);
        }, 500);
        setTimeoutIdToSearch(timeoutId);
    }
    const clearMatchedStudentList = () => {
        setMatchedStudentList([]);
    }
    const getDataItemTextDefault = ({ id, name }) => {
        return `${name} (${id})`;
    }
    //#endregion
    return (
    <SearchDialogAlert 
        title="Agregar alumno(a)"
        notFoundTitle="Alumno(a) no encontrado"
        placeholder="Escribe el código del alumno(a)"
        minLength={7}
        maxLength={9}
        show={dialogShow.value}
        toggleShow={dialogShow.toggle}
        changeSearchField={changeStudent}
        data={matchedStudentList}
        getDataItemText={getDataItemText || getDataItemTextDefault}
        fillData={fillMatchedStudentList}
        clearData={clearMatchedStudentList}
        loadingSearch={!loadingRequest.value.hidden}
        styles={{
            width: "600px",
            padding: "0 60px"
        }}/>
    );
}

export default DialogSearchStudent;